import { ContractorContainer } from './ContractorContainer';

const name = 'ContractorContainer';

export { ContractorContainer, name };
